import { customAxiosBE } from "../config";
import axios from "axios";
import { parsePaginationParams } from "../../utils/other";
import moment from "moment";

export async function getAllAllotmentsAPI(params) {
    const parsedParams = parsePaginationParams(params)
    return customAxiosBE.get(`/allotment?${parsedParams}`)
}

export async function numberOfAllotmentByTripApi(tripId, journeyDate) {
    const dateFrom = moment(journeyDate).format("YYYY-MM-DD");
    const dateTo = moment(journeyDate).format("YYYY-MM-DD");
    return customAxiosBE.get(`/allotment/count/trip/${tripId}?dateFrom=${dateFrom}&dateTo=${dateTo}`)
}

export async function allotmentsPreview({ date, tripId, operatorId }) {
    const url = tripId
        ? `/dayTripAllotment/byJourneyDate/?journeyDate=${date}&tripId=${tripId}&operatorId=${operatorId}`
        : `/dayTripAllotment/byJourneyDate/?journeyDate=${date}&operatorId=${operatorId}`;

    return customAxiosBE.get(url);
}

export async function getAllAllotmentsByIdAPI(tripHasVehicleId) {
    return customAxiosBE.get(`/allotment/tripHasVehicleId/${tripHasVehicleId}`)
}
export async function getAllotmentsByLinkIdsAPI(payload) {
    return customAxiosBE.post(`/link-allotment`, payload)
}

export async function getAllAllotmentsByTripIdAPI(tripId) {
    return customAxiosBE.get(`/allotment/tripId/${tripId}`)
}

// alotmani polaska samo za date operatere (prevoznik + ova stanica), bez tuđih stanica
export async function getAllotmentsByTripIdForOperatorsAPI(tripId, operatorIds) {
    return customAxiosBE.get(`/allotment/tripId/${tripId}/for-operators`, {
        params: {operatorIds: (operatorIds || []).join(',')}
    })
}

// alotmani ovog vozila u kojima je ova stanica vlasnik (sama ili deljeno sa nekim)
export async function getAllotmentsByVehicleForStationAPI(tripId, tripHasVehicleId, stationId) {
    return customAxiosBE.get(`/allotment/tripId/${tripId}/tripHasVehicle/${tripHasVehicleId}/for-station`, {
        params: {stationId}
    })
}

export async function getLatestIssuedTicketByJourneyDate(tripId) {
    return customAxiosBE.get(`/allotment/getLatestIssuedTicketByJourneyDate/${tripId}`)
}

export async function getAllAllotmentsByLineIdAPI(lineId) {
    return customAxiosBE.get(`/allotment/lineId/${lineId}`)
}

export async function getHasTicketsAPI(id) {
    return customAxiosBE.get(`/allotment/hasTickets/${id}`)
}

export async function postLinkedApi(data) {
    return customAxiosBE.post(`/allotment/kalem/trips`, data)
}

export async function postLinkedTripIdsApi(tripIds) {
    return customAxiosBE.post(`/allotment/kalem/trip-links`, tripIds)
}

export async function deleteAllotmentById(id) {
    return customAxiosBE.delete(`/allotment/delete/${id}`)
}

export async function getStationNamesByAlId(ids) {
    return customAxiosBE.post(`/allotment/station-names`, ids)
}

export async function getAllAllotmentsByTripHasVehicleId({ tripHasVehicleId, dateFrom, dateTo }) {
    return customAxiosBE.get('/allotment/tripHasVehicle', {
        params: {
            tripHasVehicleId,
            dateFrom,
            dateTo
        }
    });
}


export const searchVisibleAllotmentAPI = async (data, stationOperatorId, cancelToken) => {
    let response
    const { name, operatorName, operatorIds, isInstant, isOld, isActive,
        dateTo, dateFrom, stationDepartureName, stationArrivalName, isAssigned, lineOperatorId } = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`allotment/searchVisible?stationOperatorId=${stationOperatorId}&${parsedParams}`,
            {
                lineName: name,
                stationDepartureName: stationDepartureName?.stationName || null,
                stationArrivalName: stationArrivalName?.stationName || null,
                operatorName: operatorName,
                dateTo: dateTo ? moment.utc(dateTo).format("YYYY-MM-DD") : null,
                dateFrom: dateFrom ? moment.utc(dateFrom).format("YYYY-MM-DD") : null,
                operatorIds: operatorIds || null,
                lineOperatorId: lineOperatorId || null,
                isInstant: isInstant === 1 ? null : isInstant,
                isOld: isOld === 1 ? null : isOld,
                isActive: isActive === 1 ? null : isActive,
                isAssigned: isAssigned
            }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            }
        });
    return response
}

export const searchAllotmentAPI = async (data, cancelToken) => {
    let response
    const { name, operatorName, operatorIds, isInstant, isOld, isActive,
        dateTo, dateFrom, stationDepartureName, stationArrivalName, isAssigned, lineOperatorId } = data
    const parsedParams = parsePaginationParams(data)
    await customAxiosBE
        .post(`allotment/search?${parsedParams}`,
            {
                lineName: name,
                stationDepartureName: stationDepartureName?.stationName || null,
                stationArrivalName: stationArrivalName?.stationName || null,
                operatorName: operatorName,
                dateTo: dateTo ? moment.utc(dateTo).format("YYYY-MM-DD") : null,
                dateFrom: dateFrom ? moment.utc(dateFrom).format("YYYY-MM-DD") : null,
                operatorIds: operatorIds || null,
                lineOperatorId: lineOperatorId || null,
                isInstant: isInstant === 1 ? null : isInstant,
                isOld: isOld === 1 ? null : isOld,
                isActive: isActive === 1 ? null : isActive,
                isAssigned: isAssigned
            }, {
            cancelToken
        })
        .then((r) => {
            response = r.data
        })
        .catch(error => {
            if (axios.isCancel(error)) {
                console.error('Request canceled', error.message);
            } else {
                // handle error response
            }
        });
    return response
}


export const insertAllotmentAPI = async (data) => {
    try {
        return await customAxiosBE.post(`/allotment/`, data);
    } catch (e) {
        throw e;
    }
};

// „Idi na alotman": kreiraj alotman stanice + auto-iseci iz preklapajućih (suboperaterovih)
export const insertAllotmentWithCarveAPI = async (data) => {
    try {
        return await customAxiosBE.post(`/allotment/with-carve`, data);
    } catch (e) {
        throw e;
    }
};

export const insertInstantAllotmentAPI = async (data) => {
    try {
        return await customAxiosBE.post(`/allotment/instant`, data);
    } catch (e) {
        throw e;
    }
};

export const updateAllotmentAPI = (data) => {
    const { splitPeriod, ...payload } = data;
    return customAxiosBE.put(`/allotment/${data.tripHasVehicleId}?splitPeriod=${splitPeriod}`, payload);
}

export const getAllotmentByIDAPI = async (id) => {
    return customAxiosBE.get(`/allotment/${id}`);
}


export const getAvailableAllotments = async (data) => {
    return customAxiosBE.get(`/allotment/available`, { params: data });
}

// M1 board: read-only snapshot (particija + zauzete ćelije + neaktivni dani)
export async function getBoardSnapshotAPI(tripHasVehicleId, dateFrom, dateTo) {
    return customAxiosBE.get(`/allotment/board`, { params: { tripHasVehicleId, dateFrom, dateTo } });
}

// M3 board: tiling apply (split + dodela operatera). Vraća {ok, partitionVersion, conflicts[]}.
export async function applyTilingAPI(payload) {
    return customAxiosBE.post(`/allotment/board/apply`, payload);
}
